import React, { useEffect, useRef, useState } from "react";

export default function PromoCarousel({ slides = [], intervalMs = 4000 }) {
  const [idx, setIdx] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!slides.length) return;

    timerRef.current = setInterval(() => {
      setIdx((i) => (i + 1) % slides.length);
    }, intervalMs);

    return () => clearInterval(timerRef.current);
  }, [slides, intervalMs]);

  if (!slides.length) return null;

  return (
    <section className="hp-carousel" aria-label="Promozioni">
      {slides.map((s, i) => (
        <div className={`hp-slide ${i === idx ? "is-active" : ""}`} key={s.id ?? i}>
          <img src={s.img} alt={s.alt || s.title || "Promo"} />
        </div>
      ))}

      <div className="hp-dots" role="tablist" aria-label="Indicatori slide">
        {slides.map((_, i) => (
          <button
            key={i}
            className={`hp-dot ${i === idx ? "is-active" : ""}`}
            aria-label={`Vai alla slide ${i + 1}`}
            onClick={() => setIdx(i)}
            type="button"
          />
        ))}
      </div>
    </section>
  );
}